module.exports = __webpack_public_path__ + "384ba1013e65c7c1f5b48ec4bc45df52.png";